import { render } from "./KioskCardReload.vue?vue&type=template&id=2118f9d3"
import script from "./KioskCardReload.vue?vue&type=script&lang=js"
export * from "./KioskCardReload.vue?vue&type=script&lang=js"
script.render = render

export default script